// extracted by mini-css-extract-plugin
export default {"bg":"styles_bg__V1NJ4","container":"styles_container__ytjt+","scroll":"styles_scroll__GWEH1"};